/**
 * SubscriptionsPage
 *
 * Backend-driven wrapper that shows the new bundle selection UI
 * or the old subscriptions page based on whether bundling is enabled.
 */

import { SubscriptionsPage as SubscriptionsPageLegacy } from '@features/organizations';

import { useBundlingEnabled } from './store';
import SubscriptionsBundlingPage from './SubscriptionsBundlingPage';

export default function SubscriptionsPage() {
  const { isBundlingEnabled: showBundling } = useBundlingEnabled();

  if (showBundling) {
    return <SubscriptionsBundlingPage />;
  }

  return <SubscriptionsPageLegacy />;
}
